import { Currency } from '@ps/web-core-enums';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';

import type { Text } from '../components/FieldValidationMessage/FieldValidationMessage';
import { DepositLimitHitTypes } from '../types/Cashier';
import type { Rate } from '../types/Cashier';
import { convertAmountByRate, getConversionRate, isZeroExponentCurrency } from '../utils/cashier';

import {
  TXTWCL_Please_noteX_Until_you_verify__ELL,
  TXTWCL_You_can_deposit_up_to_N0_befor_ELL
} from './tempAccountMessage.messages.json';

export const createStaticMessage = (
  selectedCurrency = Currency.USDollar,
  depositLimitHitType: DepositLimitHitTypes,
  rates: Rate[],
  remainingLimit: number
): Text => {
  const currencyRate = getConversionRate(rates, selectedCurrency);
  const translation =
    depositLimitHitType === DepositLimitHitTypes.TempAccountLimit
      ? TXTWCL_You_can_deposit_up_to_N0_befor_ELL
      : TXTWCL_Please_noteX_Until_you_verify__ELL;

  return {
    translation,
    values: {
      0: (
        <CurrencyAmount
          value={convertAmountByRate(
            Number(remainingLimit / 100),
            currencyRate,
            selectedCurrency,
            true
          )}
          isZeroExponentCurrency={isZeroExponentCurrency(selectedCurrency)}
          currency={selectedCurrency}
          dollarValue
        />
      )
    }
  };
};
